module.exports = __webpack_public_path__ + "img/hsy2.d8efd071.png";